/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import Entidades_FrontAPI, { IEntidadesData, IRetornoAjaxEntidades } from './Entidades_FrontAPI';
import { useAppContextoReact } from '../app/AppContextoReact';
import { DataType, IFormStateEntidades } from '../IFormularios';
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';
import { Order } from 'src/componentes/tabelas/ITabelas';

export default class EntidadesController extends Entidades_FrontAPI
{
    public appContext = useAppContextoReact();
    
    //#region PRODUTORA [LIST, CREATE, UPDATE, DELETE]

        async produtoraList(idProdutora?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number)
        {
            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    const res:IRetornoAjaxEntidades = await this.produtoraListaAjax(token,idProdutora,callbackDataFilter,rowsNum,pageNum);

                    return res;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async produtoraCreate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.produtoraCreateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async produtoraUpdate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.produtoraUpdateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async produtoraDelete(idProdutora:string)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.produtoraDeleteAjax(token,idProdutora);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

    //#endregion

    //#region REPOSITORIO [LIST, CREATE, UPDATE, DELETE]

        async repositorioCreate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.repositorioCreateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async repositorioList(idRepositorio?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number)
        {
            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    const res:IRetornoAjaxEntidades = await this.repositorioListaAjax(token,idRepositorio,callbackDataFilter,rowsNum,pageNum);

                    return res;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async repositorioUpdate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.repositorioUpdateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async repositorioDelete(idRepositorio:string)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.repositorioDeleteAjax(token,idRepositorio);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

    //#endregion

    //#region GÊNERO [LIST, CREATE, UPDATE, DELETE]

        async generoCreate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.generoCreateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async generoList(idGenero?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number)
        {
            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    const res:IRetornoAjaxEntidades = await this.generoListaAjax(token,idGenero,callbackDataFilter,rowsNum,pageNum);

                    return res;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async generoUpdate(data:IFormStateEntidades)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.generoUpdateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async generoDelete(idGenero:string)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.generoDeleteAjax(token,idGenero);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

    //#endregion

    //#region SÉRIES [LIST, CREATE, UPDATE, DELETE]

        async seriesCreate(data:FormData)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.seriesCreateAjax(token,data);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async seriesUpdate(data:FormData, type:DataType)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.seriesUpdateAjax(token, data, type);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async seriesList(idSerie?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number,orderBy?:string,order?:Order,sortParameter?:string)
        {
            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    const res:IRetornoAjaxEntidades = await this.seriesListaAjax(token,idSerie,callbackDataFilter,rowsNum,pageNum, orderBy, order, sortParameter);

                    return res;
                }
            }
            catch(e)
            {
                return e;
            }
        }

        async seriesDelete(idSerie:string)
        {
            let retorno: IRetornoAjaxEntidades;

            try
            {
                const token:string|undefined = await this.appContext.usuario.user.getIdToken();

                if(token)
                {
                    retorno = await this.seriesDeleteAjax(token,idSerie);

                    return retorno;
                }
            }
            catch(e)
            {
                return e;
            }
        }

    //#endregion
}